const state = {
	newReview: {
		pages: {},
		submitted: false,
		valid: false,
		stored: false
	}
};

const mutations = {
	'SET_FORM_FIELD' (state, field) {
		const newFormFieldValues = {
			id: field.id,
			value: field.value,
			valid: field.valid,
			formId: field.formId,
			returnType: field.returnType,
			apiMapping: field.apiMapping,
			changed: false
		};

		if (typeof state[field.formId].pages[field.page] === 'undefined') {
			state[field.formId].pages[field.page] = {
				fields: {},
				valid: false,
				submitted: false
			};
		}

		if (typeof state[field.formId].pages[field.page].fields[field.id] !== 'undefined') {
			newFormFieldValues.changed = true;
		}
		state[field.formId].pages[field.page].fields[field.id] = newFormFieldValues;
	},
	'SET_FORM_SUBMITTED' (state, formId) {
		state[formId].submitted = true;
	},
	'SET_FORM_STORED' (state, formId) {
		state[formId].stored = true;
	},
	'SET_FORM_VALID' (state, formId) {
		const pages = state[formId].pages;
		let valid = true;
		for (let page in pages) {
			if (pages.hasOwnProperty(page)) {
				if (!pages[page].valid) {
					valid = false;
				}
			}
		}
		state[formId].valid = valid;
	},
	'SET_PAGE_SUBMITTED' (state, args) {
		if (typeof state[args.formId].pages[args.page] !== 'undefined') {
			state[args.formId].pages[args.page].submitted = true;
		}
	},
	'SET_PAGE_VALID' (state, args) {
		if (typeof state[args.formId].pages[args.page] === 'undefined') {
			return;
		}

		const fields = state[args.formId].pages[args.page].fields;
		let valid = Object.keys(fields).length > 0;
		for (let field in fields) {
			if (fields.hasOwnProperty(field)) {
				if (!fields[field].valid) {
					valid = false;
				}
			}
		}
		state[args.formId].pages[args.page].valid = valid;
	}
};

const actions = {
	submitForm: ({commit}, formId) => {
		commit('SET_FORM_SUBMITTED', formId);
		commit('SET_FORM_VALID', formId);
	},
	storedForm: ({commit}, formId) => {
		commit('SET_FORM_STORED', formId);
	},
	storeFormField: ({commit}, field) => {
		commit('SET_FORM_FIELD', field);
	},
	submitPage: ({commit}, args) => {
		commit('SET_PAGE_SUBMITTED', args);
		commit('SET_PAGE_VALID', args);
	}
};

const getters = {
	formIsValid: (state) => (formId) => {
		return state[formId].valid;
	},
	formIsSubmitted: (state) => (formId) => {
		return state[formId].submitted;
	},
	formNewReviewIsStored: state => {
		return state.newReview.stored;
	},
	formNewReviewIsValid: (state) => (page) => {
		if (!page) {
			return false;
		}
		if (typeof state.newReview.pages[page] === 'undefined') {
			return true;
		}
		return state.newReview.pages[page].valid;
	},
	formNewReviewIsSubmitted: (state) => (page) => {
		if (typeof state.newReview.pages[page] === 'undefined') {
			return state.newReview.submitted;
		}
		return state.newReview.pages[page].submitted;
	},
	formNewReview: state => {
		return state.newReview;
	}
};

export default {
	state,
	mutations,
	actions,
	getters
};
